import React, { useEffect, useMemo } from 'react';
import GTable from '../../../../components/elements/GTable';
import { Commission } from '../../../../models/commission/Commission';
import { ITablePaginationData } from '../../../../components/elements/GTable/GTable';
import { ITableFilterItem } from '../../../../resources/interfaces';
import { useCommissions } from '../../../../hooks/commissionsHook';
import { CircleCheck } from 'lucide-react';
import ActionsPopOnMe from '../../../../components/ActionsPopOnMe';
import { showToast } from '../../../../utils/miscFunctions';

interface ICommissionsTableProps {
  commissions: Commission[];
  paginationData?: ITablePaginationData;
  loading?: boolean;
  showTitleSection?: boolean;
  showPerPage?: number;
  onPageChange?: (page: number) => void;
  onShowPerPageChange?: (page: number) => void;
  onSearchChange?: (search: string) => void;
  onRemoveFilter?: (filter: ITableFilterItem, index: number) => void;
  selectedFilters?: ITableFilterItem[];

}

const CommissionsTable = ({ commissions, paginationData, loading, showTitleSection, showPerPage, onPageChange, onShowPerPageChange, onSearchChange, onRemoveFilter, selectedFilters }: ICommissionsTableProps) => {
  const [isLoading, setIsLoading] = React.useState(loading);
  const [selectedCommissions, setSelectedCommissions] = React.useState<Commission[]>([]);
  const includesPaid = selectedCommissions.some((commission: Commission) => commission.isPaid);

  const getTableRowActions = (commission: Commission) => {
    const actions = [];


    if (!commission?.isPaid) {
      actions.push({
        label: 'Mark as paid',
        icon: <CircleCheck className="h-4 w-4" />,
        callback: () => handleMarkCommissionAsPaidAndSettle(commission)
      })
    }


    return actions;
  }

  const { handleMarkCommissionAsPaidAndSettle, CommissionsModal, columns } = useCommissions({ getTableRowActions })

  const mainActions = useMemo(() => () => {
    const actions = [];


    if (selectedCommissions && selectedCommissions?.length > 1 && !includesPaid) {
      actions.push({
        label: 'Mark as paid',
        icon: <CircleCheck className="h-4 w-4" />,
        callback: () => handleMarkCommissionAsPaidAndSettle(selectedCommissions)
      })
    }


    return actions;
  }, [selectedCommissions])

  useEffect(() => {
    setIsLoading(!!loading);
  }, [commissions]);

  useEffect(() => {
    if (includesPaid) {
      showToast.info('This list includes a paid commission')
    }
  }, [includesPaid]);

  return (
    <div>
      <div className={`${showTitleSection ? 'bg-white dark:bg-darkBg rounded-2xl shadow-sm border border-gray-200 dark:border-darkBg-border overflow-hidden' : ''}`}>
        {showTitleSection && (
          <div className="p-4 border-b border-gray-200 dark:border-darkBg-border">
            <h2 className="text-lg font-medium text-gray-900 dark:text-darkBg-mainText">Sales Transactions and Commissions</h2>
          </div>
        )}

        <div className="px-5">
          <GTable
            selectionChanged={(selectedData) => {
              setSelectedCommissions(selectedData);
            }} columns={columns}
            data={commissions}
            tableType={'commission'}
            searchPlaceholder='search by customer name or policy number'
            classes="h-fit"
            loading={isLoading}
            paginationData={paginationData}
            onPageChange={onPageChange}
            showPerPage={showPerPage}
            stickyHeader
            onShowPerPageChange={onShowPerPageChange}
            onSearch={onSearchChange}
            selectedFilters={selectedFilters}
            onRemoveFilter={onRemoveFilter}
            otherTopActions={
              mainActions()?.length > 0 ?
                <ActionsPopOnMe actions={mainActions()} /> : null
            }
          />
        </div>
        <CommissionsModal />
      </div>
    </div>
  );
};

export default CommissionsTable;
